import { useContext } from 'react';
import styles from './HeaderAdmin.module.css';
import { EstabelecimentosContext } from '../../../shared/contexts/EstabelecimentosContext';

function HeaderAdmin() {
    const nomeAdmin = localStorage.getItem("nome_usuario");
    const { estabelecimentos } = useContext(EstabelecimentosContext);

    const estabelecimentoId = localStorage.getItem("estabelecimento_id");
    const estabelecimento = estabelecimentos.find(
        e => String(e.id_estabelecimento) === String(estabelecimentoId)
    );
    const logo = estabelecimento?.logo;
    const iniciais = nomeAdmin
        .trim()
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(parte => parte[0].toUpperCase())
        .join('');

    return (
        <header className={styles.header_admin}>
            <div className={styles.titulo_area}>
                <h1>Bem-vindo de volta</h1>
                <h2 className={styles.subtitle_nomeAdmin}>Olá, <span className={styles.nomeDestaque}>{nomeAdmin.split(' ')[0]}</span></h2>
            </div>
        </header>
    );
}

export default HeaderAdmin;
